export enum SLIPPAGE_FEE {
  ZEROPOINTTHREE = '%0.3',
  ZEROPOINTFIVE = '%0.5',
  ZEROPOINTSEVENTYFIVE = '%0.75',
  ONEPOINT = '%1',
  ONEPOINTTWENTYFIVE = '%1.25',
  ONEPOINTFIVE = '%1.5',
}
